// // src/components/ContactSection.js

// import React, { useState } from "react";
// import { motion } from "framer-motion";
// import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

// const container = {
//   hidden: { opacity: 0 },
//   visible: {
//     opacity: 1,
//     transition: { staggerChildren: 0.15 }
//   }
// };

// const item = {
//   hidden: { opacity: 0, y: 40 },
//   visible: {
//     opacity: 1,
//     y: 0,
//     transition: { duration: 0.7 }
//   }
// };

// const ContactSection = () => {

//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     service: "",
//     message: ""
//   });

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     const message = `
// New Inquiry from Website

// Name: ${formData.name}
// Email: ${formData.email}
// Phone: ${formData.phone}
// Service: ${formData.service}

// Message:
// ${formData.message}
// `;

//     const whatsappNumber = "923034935404";

//     const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
//       message
//     )}`;

//     window.open(url, "_blank");

//     // reset form
//     setFormData({
//       name: "",
//       email: "",
//       phone: "",
//       service: "",
//       message: ""
//     });
//   };

//   return (
//     <section
//       id="contactus"
//       className="relative py-12 backgroundattachment bg-cover container-custom"
//       style={{
//         backgroundImage:
//           "url('https://res.cloudinary.com/dgwnm39m7/image/upload/v1772913179/eb8b4acf-4969-4f29-9a3b-b12230d4ee04_zuwi6y.jpg')",
//         backgroundPosition: "50% 50%"
//       }}
//     >
//       {/* overlay */}
//       <div className="absolute inset-0 bg-black/50"></div>

//       <motion.div
//         className="relative z-10"
//         variants={container}
//         initial="hidden"
//         whileInView="visible"
//         viewport={{ once: true }}
//       >
//         <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">

//           {/* FORM */}
//           <motion.div variants={item} className="space-y-4">

//             <div className="flex items-center gap-3">
//               <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//               <span className="text-[#c9a86c] text-xs tracking-[0.25em] uppercase font-semibold">
//                 Get In Touch
//               </span>
//               <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             </div>

//             <h2 className="text-4xl lg:text-5xl font-light leading-tight text-white">
//               Send Us A <span className="font-bold text-[#c9a86c]">Message</span>
//             </h2>

//             <form
//               onSubmit={handleSubmit}
//               className="grid grid-cols-1 md:grid-cols-2 gap-4 !mt-6"
//             >

//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 onChange={handleChange}
//                 placeholder="Your Name"
//                 required
//                 className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
//               />

//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 placeholder="Email Address"
//                 required
//                 className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
//               />

//               <input
//                 type="tel"
//                 name="phone"
//                 value={formData.phone}
//                 onChange={handleChange}
//                 placeholder="Phone Number"
//                 required
//                 className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
//               />

//               <select
//                 name="service"
//                 value={formData.service}
//                 onChange={handleChange}
//                 required
//                 className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
//               >
//                 <option className="text-black px-4 py-3" value="">
//                   Service Type
//                 </option>
//                 <option className="text-black px-4 py-3 " value="Booking Inquiry">
//                   Booking Inquiry
//                 </option>
//                 <option className="text-black px-4 py-3" value="Corporate Stay">
//                   Corporate Stay
//                 </option>
//                 <option className="text-black px-4 py-3" value="General Inquiry">
//                   General Inquiry
//                 </option>
//                 <option className="text-black px-4 py-3" value="Feedback">
//                   Feedback
//                 </option>
//               </select>

//               <textarea
//                 rows="5"
//                 name="message"
//                 value={formData.message}
//                 onChange={handleChange}
//                 placeholder="Message"
//                 required
//                 className="md:col-span-2 rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
//               />

//               <button
//                 type="submit"
//                 className="md:col-span-2 bg-[#c9a86c] text-white py-4 rounded-full font-semibold hover:bg-[#b38f5a] transition-all duration-300"
//               >
//                 Send Message
//               </button>

//             </form>
//           </motion.div>

//           {/* CONTACT INFO */}
//           <motion.div variants={item}>

//             <p className="text-gray-200 mb-10 md:text-[17px] 2xl:text-lg">
//               Whether you have a question about availability, pricing, or just
//               want to say hello — our team is ready to assist.
//             </p>

//             <div className="space-y-6">

//               <div className="flex gap-4 bg-white/10 border border-white/20 p-4 rounded-xl backdrop-blur-sm">
//                 <FaMapMarkerAlt className="text-[#c9a86c] text-xl mt-1" />
//                 <div>
//                   <h3 className="font-semibold text-[#c9a86c] text-lg">
//                     Head Office
//                   </h3>
//                   <p className="text-gray-200">
//                     Centaurus Complex, Jinnah Avenue, Islamabad
//                   </p>
//                 </div>
//               </div>

//               <div className="flex gap-4 bg-white/10 p-4 border border-white/20 rounded-xl backdrop-blur-sm">
//                 <FaEnvelope className="text-[#c9a86c] text-xl mt-1" />
//                 <div>
//                   <h3 className="font-semibold text-[#c9a86c] text-lg">
//                     Email Us
//                   </h3>
//                   <p className="text-gray-200">info@stayin.com</p>
//                 </div>
//               </div>

//               <div className="flex gap-4 bg-white/10 p-4 border border-white/20 rounded-xl backdrop-blur-sm">
//                 <FaPhone className="text-[#c9a86c] text-xl mt-1" />
//                 <div>
//                   <h3 className="font-semibold text-[#c9a86c] text-lg">
//                     Call Us
//                   </h3>
//                   <p className="text-gray-200">+92 303 4935404</p>
//                 </div>
//               </div>

//             </div>

//           </motion.div>

//         </div>
//       </motion.div>
//     </section>
//   );
// };

// export default ContactSection;


// src/components/ContactSection.js

import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { FaEnvelope, FaPhone, FaMapMarkerAlt } from "react-icons/fa";

const container = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15 }
  }
};

const item = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.7 }
  }
};

const ContactSection = () => {

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    service: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const message = `
New Inquiry from Website

Name: ${formData.name}
Email: ${formData.email}
Phone: ${formData.phone}
Service: ${formData.service}

Message:
${formData.message}
`;

    const whatsappNumber = "923034935404";

    const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;

    // 👉 WhatsApp open
    window.open(url, "_blank");

    // ✅ Delay laga do (recommended)
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'conversion', {
          send_to: 'AW-18044656656/ojOzCO_arZIcEJC4rpxD'
        });
      }
    }, 300);

    // reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      service: "",
      message: ""
    });
  };

  return (
    <>
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Contact StayIN | Luxury Serviced Apartments Centaurus Islamabad</title>
        <meta name="description" content="Contact StayIN Centaurus Islamabad for luxury serviced apartment bookings. Call +92 303 4935404, email info@stayin.com or visit us at Centaurus Complex. Book your premium stay today." />
        <meta name="keywords" content="contact StayIN, Centaurus Islamabad phone number, book serviced apartments, StayIN contact, Centaurus Complex Islamabad" />
      </Helmet>

      {/* Local Business Schema */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "StayIN Centaurus Serviced Apartments",
          "image": "https://res.cloudinary.com/dgwnm39m7/image/upload/v1772913179/eb8b4acf-4969-4f29-9a3b-b12230d4ee04_zuwi6y.jpg",
          "telephone": "+923034935404",
          "email": "info@stayin.com",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Centaurus Complex, Jinnah Avenue",
            "addressLocality": "Islamabad",
            "addressCountry": "PK"
          },
          "openingHours": "Mo-Su 00:00-23:59",
          "priceRange": "$$$",
          "url": "https://stayinhospitality.com/",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+923034935404",
            "contactType": "customer service",
            "availableLanguage": ["English", "Urdu"]
          }
        })}
      </script>

      <section
        id="contactus"
        className="relative py-12 backgroundattachment bg-cover container-custom"
        style={{
          backgroundImage:
            "url('https://res.cloudinary.com/dgwnm39m7/image/upload/v1772913179/eb8b4acf-4969-4f29-9a3b-b12230d4ee04_zuwi6y.jpg')",
          backgroundPosition: "50% 50%"
        }}
        aria-label="Contact StayIN Centaurus Islamabad for luxury apartment bookings"
      >
        {/* overlay */}
        <div className="absolute inset-0 bg-black/50"></div>

        <motion.div
          className="relative z-10"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <div className="grid lg:grid-cols-2 gap-8 md:gap-16 items-center">

            {/* FORM */}
            <motion.div variants={item} className="space-y-4">

              <div className="flex items-center gap-3">
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
                <span className="text-[#c9a86c] text-xs tracking-[0.25em] uppercase font-semibold">
                  Get In Touch
                </span>
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              </div>

              <h2 className="text-4xl lg:text-5xl font-light leading-tight text-white">
                Send Us A <span className="font-bold text-[#c9a86c]">Message</span>
              </h2>

              <form
                onSubmit={handleSubmit}
                className="grid grid-cols-1 md:grid-cols-2 gap-4 !mt-6"
              >

                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                  className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
                  aria-label="Your full name"
                />

                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email Address"
                  required
                  className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
                  aria-label="Your email address"
                />

                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Phone Number"
                  required
                  className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
                  aria-label="Your phone number"
                />

                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                  className="rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
                  aria-label="Select service type"
                >
                  <option className="text-black px-4 py-3" value="">
                    Service Type
                  </option>
                  <option className="text-black px-4 py-3" value="Booking Inquiry">
                    Booking Inquiry
                  </option>
                  <option className="text-black px-4 py-3" value="Corporate Stay">
                    Corporate Stay
                  </option>
                  <option className="text-black px-4 py-3" value="General Inquiry">
                    General Inquiry
                  </option>
                  <option className="text-black px-4 py-3" value="Feedback">
                    Feedback
                  </option>
                </select>

                <textarea
                  rows="5"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message"
                  required
                  className="md:col-span-2 rounded-xl bg-white/10 border border-white/20 text-white px-4 py-3 focus:outline-none focus:border-[#c9a86c]"
                  aria-label="Your message"
                />

                <button
                  type="submit"
                  className="md:col-span-2 bg-[#c9a86c] text-white py-4 rounded-full font-semibold hover:bg-[#b38f5a] transition-all duration-300"
                  aria-label="Send inquiry message via WhatsApp"
                >
                  Send Message
                </button>

              </form>
            </motion.div>

            {/* CONTACT INFO */}
            <motion.div variants={item}>

              <p className="text-gray-200 mb-10 md:text-[17px] 2xl:text-lg">
                Whether you have a question about availability, pricing, or just
                want to say hello — our team is ready to assist.
              </p>

              <div className="space-y-6">

                <div className="flex gap-4 bg-white/10 border border-white/20 p-4 rounded-xl backdrop-blur-sm">
                  <FaMapMarkerAlt className="text-[#c9a86c] text-xl mt-1" aria-hidden="true" />
                  <div>
                    <h3 className="font-semibold text-[#c9a86c] text-lg">
                      Head Office
                    </h3>
                    <p className="text-gray-200">
                      Centaurus Complex, Jinnah Avenue, Islamabad
                    </p>
                  </div>
                </div>

                <div className="flex gap-4 bg-white/10 p-4 border border-white/20 rounded-xl backdrop-blur-sm">
                  <FaEnvelope className="text-[#c9a86c] text-xl mt-1" aria-hidden="true" />
                  <div>
                    <h3 className="font-semibold text-[#c9a86c] text-lg">
                      Email Us
                    </h3>
                    <p className="text-gray-200">
                      <a href="mailto:info@stayinhospitality.com" className="hover:text-[#c9a86c] transition">
                        info@stayinhospitality.com
                      </a>
                    </p>
                  </div>
                </div>

                <div className="flex gap-4 bg-white/10 p-4 border border-white/20 rounded-xl backdrop-blur-sm">
                  <FaPhone className="text-[#c9a86c] text-xl mt-1" aria-hidden="true" />
                  <div>
                    <h3 className="font-semibold text-[#c9a86c] text-lg">
                      Call Us
                    </h3>
                    <p className="text-gray-200">
                      <a href="tel:+923034935404" className="hover:text-[#c9a86c] transition">
                        +92 303 4935404
                      </a>
                    </p>
                  </div>
                </div>

              </div>

            </motion.div>

          </div>
        </motion.div>
      </section>
    </>
  );
};

export default ContactSection;